export const P0003601ProgrammeFiltrationAuto = [
  { ref: 0, label: 'P0003601.programme.prog72H', visible: false, value: '72H' },
  {
    ref: 1,
    label: 'P0003601.programme.horlogeHiver',
    visible: true,
    value: 'HIVER',
  },
  {
    ref: 2,
    label: 'P0003601.programme.horlogeEte',
    visible: true,
    value: 'ETE',
  },
];
